import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface TableColumn {
  key: string;
  header: string;
  className?: string;
  /** When set, score color is based on this key (e.g. for "80 (Very Good)" display with numeric color). */
  scoreKey?: string;
}

export interface TableRow {
  [key: string]: any;
  is_your_brand?: boolean;
}

@Component({
  selector: 'app-common-performance-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './common-performance-table.component.html',
  styleUrl: './common-performance-table.component.scss'
})
export class CommonPerformanceTableComponent {
  @Input() rows: TableRow[] = [];
  @Input() columns: TableColumn[] = [];
  @Input() title: string = 'Performance Table';

  // Helper method to get score color based on value (accepts number or string)
  getScoreColor(score: number | string | null | undefined): string {
    const n = typeof score === 'number' ? score : (typeof score === 'string' ? parseInt(score, 10) : NaN);
    if (Number.isNaN(n)) return '';
    if (n >= 80) return '#4caf50'; // Green
    if (n >= 60) return '#ff9800'; // Orange
    if (n >= 40) return '#ff5722'; // Red-Orange
    return '#f44336'; // Red
  }

  // Helper method to get score label based on value
  getScoreLabel(score: number): string {
    if (score >= 90) return 'Excellent';
    if (score >= 80) return 'Very Good';
    if (score >= 70) return 'Good';
    if (score >= 60) return 'Fair';
    return 'Poor';
  }

  // Helper method to get confidence percentage
  getConfidencePercentage(confidence: number): number {
    return Math.round((confidence || 0) * 100);
  }

  // Helper method to get nested object values
  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((current, key) => {
      return current && current[key] !== undefined ? current[key] : null;
    }, obj);
  }
}
